



























import ActionButton from '@/components/ActionButton.vue'
import { getAgencies } from '@/api/Agency/agency.api'
import { Agency } from '@/api/Agency/agency.interface'
import { tableHandler } from '@/utils/mixins/tableHandler'
import PriceSettings from '@/components/Services/Remittances/PriceSettings/PriceSettings.vue'
import PriceSettingsDialog from '@/components/Services/Remittances/PriceSettings/PriceSettingsDialog.vue'
import { RemittancePrice } from '@/utils/interfaces/remittance.interface'
import {
  createRemittancePrice,
  getRemittancePrices,
} from '@/api/Remittances/remittances.api'
import PlatformPriceFilter from '~/components/Services/Remittances/PriceSettings/PlatformPriceFilter.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'

export default tableHandler<Agency>().extend({
  components: {
    appActionButton: ActionButton,
    appPriceSettings: PriceSettings,
    appPriceSettingsDialog: PriceSettingsDialog,
    PlatformPriceFilter,
    FlatCard,
    FlatTable,
  },
  data() {
    return {
      filterModel: false,
      dialogModel: false,
      getter: getAgencies,
      priceItem: null as null | RemittancePrice,
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('address'),
          value: 'full_address',
        },
        {
          text: this.$t('remittance.price-settings'),
          value: 'price-settings',
        },
      ],
      poster: createRemittancePrice,
      remittancePricesGetter: getRemittancePrices,
      key: 0,
    }
  },
  methods: {
    onEdit(item: RemittancePrice) {
      this.priceItem = item
      this.dialogModel = true
    },
    onNew() {
      this.priceItem = null
      this.key++
    },
  },
})
